
import { Component, Vue, Prop } from "vue-property-decorator";
import EventAlarmTags from "./EventAlarmTags.vue";
import GenericAdvancedTooltip from '../generic-advanced-tooltip/GenericAdvancedTooltip.vue';

@Component({
	components: {
		"event-alarm-tags": EventAlarmTags,
		"generic-advanced-tooltip": GenericAdvancedTooltip
	}
})
export default class EventAlarmTagsTooltip extends Vue {
	@Prop({ type: Boolean, default: false })
	readonly value: boolean;

	@Prop({ type: Number, required: false })
	readonly eventId: number;

	@Prop({ type: Number, required: false })
	readonly groupId: number;

	@Prop({ type: Boolean, default: false })
	readonly isPostEventEdit: boolean;

	private get isTooltipVisible(): boolean {
		return this.value;
	}

	private set isTooltipVisible(value: boolean) {
		this.$emit("input", value);
	}

	private closeTooltip(): void {
		this.isTooltipVisible = false;
	}

	// Conditionally render elements if we have enough information to fetch alarm tags
	private get hasEnoughEventInformation(): boolean {
		return (
			this.eventId != null && this.eventId > 0 &&
			this.groupId != null && this.groupId > 0
		);
	}
}
